<template lang="pug">
.vtal
  .row.ac.col-s
    h1 V.TAL
    AbasVtal(style="margin-left: 12px")
    Button(:layout="!open?'green-go':'red-go'" @click="open=!open" title="NOVO" :class="open?'fa-times':'fa-plus'" style="margin: 0 16px").fa
  .form(v-if="open")
    LoginVtexpForm(editavel :pode-excecao="podeExcecao" @salvo="loginSalvo" @cancelar="open = false")
  .bloco
    PendenciasTecnico(:pode-excecao="podeExcecao" :recarga="recarga" @cadastrar="abrirPendencia" @vincular="abrirPendencia" @excecao="abrirPendencia")
    LoginVtexpForm(v-if="pendencia" :key="pendencia.matricula + '/' + pendencia.acao" :matricula="pendencia.matricula" :acao="pendencia.acao" :pode-excecao="podeExcecao" @salvo="loginSalvo" @cancelar="pendencia = null")
  .filtro.row.col-s.js.ae
    .col.g3.g12-s
      label MATRICULA
      input(v-model="filtro.matricula_vtexp" placeholder="MATRICULA VTEXP")
      label.mt10 NOME
      input(v-model="filtro.nome_vtexp" placeholder="NOME VTEXP")
    .col.g3.g12-s
      label ID TÉCNICO
      input(v-model="filtro.id_doutor" placeholder="ID TÉCNICO")
      label.mt10 NOME TÉCNICO
      input(v-model="filtro.nome_doutor" placeholder="NOME TÉCNICO")
    .col.g2.g12-s
      label STATUS
      select(v-model="filtro.status")
        option(value="") TODOS
        option(value="ativo") ATIVO
        option(value="inativo") INATIVO
      label.mt10 STATUS OPERACIONAL
      select(v-model="filtro.status_operacional")
        option(value="") TODOS
        option(value=true) ATIVO
        option(value=false) INATIVO
    Button(@click="load" layout="green-go" style="margin-left:8px; align-self: flex-end") BUSCAR
  Loader(v-if="loader" layout="small")
  .lista.col(v-else)
    .item(v-for="u in lista" :key="u.id")
      .titulo.row.col-s.g12.ac(@click="editar.includes(u.id)?editar.splice(editar.indexOf(u.id), 1):editar.push(u.id)")
        .g3.g12-s.col.row-s
          label Matrícula Vtexp: 
          b &nbsp;{{u.matricula_vtexp}}
        .g3.g12-s.col.row-s
          label Nome: 
          b &nbsp;{{u.nome_vtexp}}
        .g2.g12-s.col.row-s
          label Status: 
          b &nbsp;{{u.status}}
        .g2.g12-s.col.row-s
          label Status Operacional: 
          b &nbsp;{{u.status_operacional}}
        .g2.row.je.g12-s
          Button.fa(:class="editar.includes(u.id)?'fa-times':'fa-edit'" :layout="editar.includes(u.id)?'red-go':'green-go'")
      .editar.row.js.col-s(v-if="editar.includes(u.id)")
        .col.g5.g12-s          
          label MATRICULA
          input(v-model="u.matricula_vtexp" placeholder="MATRICULA VTEXP")
          label NOME
          input(v-model="u.nome_vtexp" placeholder="NOME VTEXP")
          Button(@click="vtexpEditar(u)" layout="green-s" :loader="bloader" style="margin-top:12px") ATUALIZAR
        .tecnicos.col.g6.g11-s
          .row.ac
            h3.cp.fb TÉCNICO
            Button(v-if="u.doutor && u.doutor.status_usuario" @click="desvincular(u)" :loader="bloader" layout="red-s" title="DESVINCULA O TÉCNICO." style="margin-left:12px") DESVINCULAR
            Button(v-else :layout="!u.open?'green-go':'red-go'" @click="u.open=!u.open;lista=[...lista]" title="NOVO" :class="u.open?'fa-times':'fa-plus'" style="margin: 0 16px").fa
            .ex.cw.br(v-if="u.doutor && !u.doutor.status_usuario")
              b Técnico não possui cadastro válido.
              Button(layout="green-go" @click="excecao=true" title="EXCEÇÃO") Exceção
          .row.ae.col-s(v-if="excecao" style="margin-bottom: 12px")
            .col.g2
              label Dias
              input(v-model="u.doutor.dias" type="number" placeholder="Dias")
            .col(style="margin-left: 12px")
              label Motivo
              input(v-model="u.doutor.motivo" placeholder="Motivo")
            Button(layout="green-go" @click="vincula(u.id, { ...u.doutor, etag: u.etag }, true)" title="ASSOCIAR") Associar

          .row.g12.col-s(v-if="u.open")
            Supporter(:cb="(t)=>dadosTecnico(t,u)")
          .row.ac.g12(v-if="u.doutor" style="padding:8px")
            .g3.fb ID {{u.doutor.id}} ({{u.doutor.status_usuario}})
            .g5 {{u.doutor.nome}} ({{u.doutor.email}})
            .g4 CPF {{u.doutor.cpf | cpf}}
          .excecoes
            Button(@click="excecoes(u)" :loader="bloader" layout="green-go" title="EXCEÇÕES") Exceções
            .list.g11(v-if="u.excecoes && u.excecoes.length")
              .row.font-12.tc
                b.g2.cp TÉCNICO
                b.g3.cp DIAS
                b.g4.cp MOTIVO
                b.g3.cp CRIADO POR
              .container
                .mt10.row.ac.tc(v-for="e in u.excecoes" :key="'e'+e.id")
                  .g2 {{e.nome_doutor}}
                  .g3.col {{e.dias}} dias, expira 
                    | em {{e.expira_em | datetime}}
                  .g4 {{e.motivo}}
                  .g3.col {{e.nome_criado_por}} 
                    | em {{e.criado_em | datetime}}
      .detail.row.ae.js.g12(v-if="editar.includes(u.id)")
        span Criado em 
          b {{u.criado_em | datetime }}
          br
          span por
            b &nbsp;{{u.nome_criado_por}}
        span(v-if="u.alterado_em") Alterado em 
          b {{u.alterado_em | datetime }}
          br
          span por
            b &nbsp;{{u.nome_alterado_por}}
        Button.fa.fa-trash(@click="excluir(u)" :loader="bloader" layout="red-go" title="Excluir")
        Button(v-if="u.status=='ativo'" @click="desativar(u)" :loader="bloader" layout="red-s") DESATIVAR
        Button(v-if="u.status=='inativo'" @click="ativar(u)" :loader="bloader" layout="green-go white") ATIVAR
          
        .row

    // Supporter(:cb="(sp)=>form.id_doutor=sp.id")
    // .form(v-if="form.id_doutor")
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button";
import Loader from "@/components/Loader";
import Supporter from "@/views/admin/components/Supporter";
import AbasVtal from "@/views/admin/components/AbasVtal";
import PendenciasTecnico from "@/views/admin/components/PendenciasTecnico";
import LoginVtexpForm from "@/views/admin/components/LoginVtexpForm";

// A liberação excepcional é do Diretor de Operação (e da TI, no suporte): o backend recusa os
// outros grupos com 403, e o botão inútil só confundiria.
const GRUPOS_EXCECAO = ["TI", "Diretor de Operação"]

export default {
  name: "Vtal",
  components: { Button, Supporter, Loader, AbasVtal, PendenciasTecnico, LoginVtexpForm },
  data() {
    return {
      open: false,
      loader: false,
      bloader: false,
      filtro: { matricula_vtexp: "", nome_vtexp: "", nome_doutor: "", id_doutor: null, status: "", status_operacional: "" },
      tfiltro: { nome: "", email: "", cpf: "", cnpj: "" },
      money: { decimal: ",", thousands: ".", precision: 2, masked: false },
      form: { id_doutor: null },
      lista: [],
      editar: [],
      excecao: false,
      pendencia: null,
      recarga: 0,
    };
  },
  computed: {
    ...mapGetters("user", ["user"]),
    podeExcecao() { return GRUPOS_EXCECAO.includes((this.user || {}).grupo) },
  },
  methods: {
    ...mapActions("admin", ["VTEXP_EXCECOES", "VTEXP_EDITAR", "VTEXP_LISTA", "VTEXP_VINCULA_EXCECAO", "VTEXP_ATIVA", "VTEXP_DESVINCULA", "VTEXP_VINCULA", "VTEXP_DESATIVA", "VTEXP_EXCLUIR"]),
    async excecoes(u) {
     
      this.bloader = true
      let { data } = await this.VTEXP_EXCECOES(u.id)
      u.excecoes = data
      this.bloader = false
      
    },
    async vtexpEditar(u) {
      this.bloader = true
      await this.VTEXP_EDITAR({ id: u.id, nome_vtexp: u.nome_vtexp, matricula_vtexp: u.matricula_vtexp, etag: u.etag })
      this.bloader = false
      this.load()
    },
    async desativar(u) {
      if (confirm(`Tem certeza que deseja desativar o usuário: ${u.nome_vtexp}?`)) {
        this.bloader = true
        await this.VTEXP_DESATIVA(u.id)
        this.bloader = false
        this.load()
      }
    },
    async ativar(u) {
      if (confirm(`Tem certeza que deseja ativar o usuário: ${u.nome_vtexp}?`)) {
        this.bloader = true
        await this.VTEXP_ATIVA(u.id)
        this.bloader = false
        this.load()
      }
    },
    async excluir(u) {
      if (confirm(`Tem certeza que deseja EXCLUIR o usuário: ${u.nome_vtexp}?`)) {
        this.bloader = true
        await this.VTEXP_EXCLUIR(u.id)
        this.bloader = false
        this.load()
      }
    },
    async load() {
      this.loader = true
      let d = { ...this.filtro }
      Object.keys(d).map(attr => (d[attr] === "" || d[attr] === null) && delete d[attr]);
      let { data } = await this.VTEXP_LISTA(d)
      this.lista = data
      this.loader = false
    },
    async desvincular(u) {
      this.bloader = true
      if (confirm(`Desvincular o técnico ${u.doutor.nome}?`))
        await this.VTEXP_DESVINCULA({ id: u.id, etag: u.etag })
      this.bloader = false
      this.load()
    },
    async vincula(id, u, e = false) {
      this.bloader = true
      this.excecao = false
      let r = e ? await this.VTEXP_VINCULA_EXCECAO({ id: id, etag: u.etag, id_doutor: u.id, dias: parseInt(u.dias), motivo: u.motivo })
        : await this.VTEXP_VINCULA({ id: id, etag: u.etag, id_doutor: u.id })
      this.bloader = false

      if ([403].includes(r.status)) {
        u.dias = 1
        u.motivo = ""
        this.excecao = true
      } else this.load()

    },
    // Pendência escolhida na lista do topo (sc-9881): abre o formulário pela sugestão a partir dela.
    abrirPendencia(p) {
      this.pendencia = p
    },
    // Cadastro, vínculo ou exceção feitos, pela pendência ou pelo NOVO: fecha o formulário, a
    // pendência some ou muda de situação na recarga, e o login novo aparece na lista de cadastro.
    loginSalvo() {
      this.pendencia = null
      this.open = false
      this.recarga++
      this.load()
    },
    async dadosTecnico(t, u) {
      this.excecao = false
      u.doutor = t
      if (t.situacao_cadastral_cnpj) this.vincula(u.id, { ...u.doutor, etag: u.etag })
      u.open = false
      this.lista = [...this.lista]
    },
  }

};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.vtal
  @include page
  h1
    font-size: 32px
    height: 10px
    margin-top: 2px
    margin-bottom: 40px
  h3
    margin-left: 12px
  .form
    margin-bottom: 8px
  .bloco
    @include card
    margin-top: 8px
  .filtro
    @include label
    padding: 20px
  .lista
    overflow: auto
    max-height: 78vh
    border-radius: 16px
  .item
    @include card
    margin-top: 10px
    border-radius: 12px
    &:hover
      border: 2px solid $purple
      border-bottom: 3px solid $purple
    label
      @include label
    .titulo
      cursor: pointer
  .editar
    background: rgba(#f1f1f1,.7)
    border-radius: 12px
    padding: 20px
    margin-top: 20px
    .button-green-s
      width: 100px
      height: 40px
  .tecnicos
    background: rgba(#f1f1f1,.7)
    border-left: 1px solid #ccc
    padding-left: 30px
    @media(max-width: $small)
      margin-top: 30px
    h3
      margin-left: 0
    .supporter
      width: 100%
      padding: 4px 10px
      margin-bottom: 12px
    .ex
      border-radius: 8px
      b
        padding: 0 12px
    .excecoes
      margin-top: 12px
      .list
        margin-top: 12px
        font-size: 11px
        .container
          max-height: 300px
          overflow: auto
        .mt10
          padding: 6px 0
          &:nth-child(even)
            background: #eee
            border-radius: 4px
  .detail
    padding: 10px
    padding-top: 30px
</style>